
// TODO predelat selectory, at jsou hlavne i pro registracni formular a univerzalne
const ICOfield = $("[data-cis='ares-validation']");
const button_ares = '<button id="validateAres" class="c-btn c-btn--primary">Vyplnit z ARES</button>';
const labelAres = $("label[for$='identification_number']");
let jmeno = $('[id$="invoicing_address_name"]')
if(!jmeno.length){
    jmeno = $('[id$="company"]');
}
const ulice = $('[id$="invoicing_address_street"]');
const mesto = $('[id$="invoicing_address_city"]');
const psc = $('[id$="invoicing_address_zipcode"]');
const dic = $('[id$="tax_identity"]');

// checkeneme, jestli je valdiace zapnuta - podle data-cis atributu v ICO fieldu
if (ICOfield.length) {

    // vytvorim button an validaci, zakladne skryty
    labelAres.parent().append(button_ares);


// odstranim mezery z IC
    ICOfield.on('change keypress', function (e) {
        $(this).val($(this).val().trim().replace(/\s+/g, ''));
    });

}
//zobrazim pokud mam hodnotu, pokud ne zase skryju
ICOfield.on('change keypress', function (e) {
    if (ICOfield.val().length > 0) {

        //pridam nebo odeberu tlacitko ares, pokdu mam neco v ico fieldu
        $('#validateAres').show();
    } else {
        $('#validateAres').hide();
    }
});


//overeni IC ares
$(document).on("click", "#validateAres", function (e) {
    let vyplneno_dobre;
    e.preventDefault();


    if (validaceIco(ICOfield.val())) {
        vyplneno_dobre = true;
    } else { //ok
        alert("Toto IČO neexistuje nebo má špatný formát \n IČO musí obsahovat právě 8 číslic, starší prosím doplňte odpředu 0");
        vyplneno_dobre = false;
    }

    // mame spravnz format ICO - musi mit 8 cisel
    if (vyplneno_dobre === true) { //pokud je naplnene (a dobre) ICO ve fakturacnich udajich

        const ico_ajax = ICOfield.val();

        // vytahneme data z aresu
        $.ajax({
            url: ABSOLUTE_URL + "plugins/eshop/classes/ares.php",
            type: "POST",
            dataType: "JSON",
            data: {
                ico_ajax_send: ico_ajax,
            },
            success: function (data) {

                //dosadime tam kam potrebujeme
                if(typeof data.ares != 'undefined' && data.success) {
                    jmeno.val(data.ares.ares_firma_fin);
                    ulice.val(data.ares.ares_ulice_fin);
                    mesto.val(data.ares.ares_mesto_fin);
                    psc.val(data.ares.ares_psc_fin);
                    dic.val(data.ares.ares_dic_fin);

                }else{

                    alert('Něco se pokaazilo !');
                }
            }
        });
    }
});


function validaceIco(ico)
{
    let a = 0;
    if (ico.length !== 8) {return false;}
    let b = ico.split('');
    let c = 0;
    for (var i = 0; i < 7; i++) {
        a += (parseInt(b[i]) * (8 - i));
    }
    a = a % 11;
    c = 11 - a;
    if (a === 1) {c = 0;}
    if (a === 0) {c = 1;}
    if (a === 10) {c = 1;}
    return parseInt(b[7]) === c;


}